import React from "react";
import { FaSpinner } from "react-icons/fa";

const AlertProgres = ({ isOpen, title, subtitle }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className=" bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        <div className="flex justify-center items-center">
          <FaSpinner className="animate-spin text-4xl" />
        </div>
        <h3 className="text-xl text-center font-normal text-gray-500 mt-5 mb-6">
          {title}
        </h3>
        <p className="text-sm mb-4 text-center">{subtitle}</p>
      </div>
    </div>
  );
};

export default AlertProgres;
